<template>
    <layout-basic>
        <v-container fluid>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-actions>
                            <v-text-field
                            class="search-box"
                            placeholder="Search Groups"
                            prepend-icon="fa-search"
                            v-model="search"
                            type="text"
                            clearable
                            clear-icon="fa-times"
                            @click:clear="resetSearch"
                            @change="applySearch"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
                        <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                        <v-data-table
                        :headers="headers"
                        :options.sync="options"
                        :server-items-length="serverItemsLength"
                        v-show="!loading"
                        :items="groups"
                        ></v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import PartnerAPI from "@/api/partner.js";
    import LayoutBasic from "@/layouts/PartnerHub";
    export default {
        name: "GroupReport",
        components: {
            LayoutBasic
        },
        data() {
            return {
                headers: [
                    { text: "Name", value: "name" },
                    { text: "Users", value: "total_users", sortable: false },
                    { text: "Courses", value: "total_courses", sortable: false },
                    { text: "Playlists", value: "total_channels", sortable: false },
                ],
                groups: [],
                pagination: {},
                options: {},
                loading: false,
                search: "",
                searchParams: "",
                id: this.$route.params.id
            };
        },
        computed: {
            serverItemsLength: function() {
                return this.pagination.total;
            },
            itemsPerPage: function() {
                return this.pagination.per_page;
            },
            page: function() {
                return this.pagination.current_page;
            },
            params: function() {
                return this.$gf.getQueryString(this.options) + this.searchParams;
            },
            isTabletOrDesktop() {
                const width = this.$vuetify.breakpoint.width;
                return width >= 820;
            },
        },
        watch: {
            options: {
                handler() {
                    this.getGroups();
                },
                deep: true
            }
        },
        methods: {
            resetSearch() {
                this.options.page = 1;
                this.searchParams = "";
                this.getGroups();
            },
            applySearch() {
                this.options.page = 1;
                this.searchParams = this.search != null ? this.params + "&search=name:" + this.search : this.params;
                this.getGroups();
            },
            getGroups() {
                this.loading = true;
                PartnerAPI.getGroups(this.params, "", this.id).then(resp => {
                    this.loading = false;
                    this.groups = resp.data.data;
                    this.pagination = resp.data.meta.pagination;
                });
            },
            applyGroupSearch() {
                this.groupSearchParams =
                this.groupParams + "&search=name:" + this.groupSearch;
                this.getGroups();
            }
        }
    };
</script>
